import { useEffect, useState } from "react";
import * as configUtils from "util/config";

export const usePhoneAreaCodesArg = () => {
    const [argAreaCodes, setArgAreaCodes] = useState([]);

    useEffect(() => {
        const areaCodes = configUtils.get("phone.areaCodes.arg");
        if (areaCodes && !argAreaCodes.length) {
            setArgAreaCodes(areaCodes.split("|"));
        }
    }, []);

    return { argAreaCodes };
};

export default usePhoneAreaCodesArg;
